import {
  FormControl,
  InputLabel,
  InputBase,
  FormHelperText,
} from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';

const Input = withStyles(theme => ({
  root: {
    height: 50,
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: '1px solid #c7c7c7',
    borderRadius: 4,
    fontSize: 20,
    lineHeight: '24px',
    padding: '12px 24px 14px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },

    [theme.breakpoints.up('sm')]: {
      borderRadius: 50,
    },
  },
}))(InputBase);

const TextField = props => {
  const { label, style, onChange, inputRef, name, helperText } = props;
  return (
    <FormControl style={{ width: '100%', maxWidth: 468, ...style }}>
      <InputLabel shrink>{label}</InputLabel>
      <Input inputRef={inputRef} name={name} onChange={onChange} />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default TextField;
